import DesktopLayout from './DesktopLayout.';

export default DesktopLayout;
